import { actions, response } from 'actions';
import { consoleLogger } from 'helpers';
import { Auth } from 'aws-amplify';
import axios from 'axios';
import clientConfig from 'clientConfig';

const convertData = (item) => ({
  product_cd: item.pgsetting.product_cd,
  destination: item.pgsetting.destination,
  model: item.pgsetting.model,
  alias: item.pgsetting.alias,
  filename: item.pgsetting.filename,
  created_at: item.pgsetting.created_at,
  updated_at: item.pgsetting.updated_at
});


/**
 * プログラムファイルを一覧取得する
 * @return {object} 処理結果 
 */
export const getProgramSettings = (cancelToken) => async dispatch => {
  const currentSession = await Auth.currentSession();
  const url = clientConfig['api_url'] + '/srv/pgsettings/';
  const requestData = {
    method: 'get',
    url: url,
    headers: { 'Authorization': currentSession.idToken.jwtToken },
    cancelToken: cancelToken.token,
  };
  const result = {...response};
  return new Promise((resolve) => {
    axios(requestData)
      .then(res => {
        consoleLogger('API GET:' + url);
        consoleLogger(res);
        if (res.status === 200) {
          const items = [];
          for (const key in res.data.items) {
            items.push(convertData(res.data.items[key]));
          }
          result.count = res.data.items.length;
          dispatch({
            type: actions.FETCH_PROGRAM_SETTINGS,
            items: items,
          });
        } else {
          result.errcode = res.data.errcode;
        }
        resolve(result);
      }).catch(err => {
        consoleLogger(err);
        if (axios.isCancel(err)) {
          return false;
        } else {
          if (err.response !== undefined) {
            result.status = err.response.status;
            result.errcode = err.response.data.errcode;  
          } else {
            result.status = 500;
            result.errcode = err.message;  
          }
          resolve(result);       
        }
      });
  });
};

/**
 * 指定した調整プログラム設定を取得する
 * @param  {string} productCd プロダクトコード
 * @return {object} 処理結果 
 */
export const getProgramSetting = (productCd, cancelToken) => async dispatch => {
  const currentSession = await Auth.currentSession();
  const url = clientConfig['api_url'] + '/srv/pgsettings/' + productCd;
  const requestData = {
    method: 'get',
    url: url,
    headers: { 'Authorization': currentSession.idToken.jwtToken },
    cancelToken: cancelToken.token,
  };
  const result = {...response};
  return new Promise((resolve) => {
    axios(requestData)
      .then(res => {
        consoleLogger('API GET:' + url);
        consoleLogger(res);
        if (res.status === 200) {
          const item = convertData(res.data.Item);
          result.count = 1;
          result.data = item;
          dispatch({
            type: actions.FETCH_PROGRAM_SETTING,
            product_cd: productCd,
            item: result.data,
          });
        } else {
          result.errcode = res.data.errcode;
        }
        resolve(result);
      }).catch(err => {
        consoleLogger(err);
        if (axios.isCancel(err)) {
          return false;
        } else {
          if (err.response !== undefined) {
            result.status = err.response.status;
            result.errcode = err.response.data.errcode;  
          } else {
            result.status = 500;
            result.errcode = err.message;  
          }
          resolve(result);       
        }      
      });
  });
};

/**
 * 指定した調整プログラム設定を削除する
 * @param  {string} productCd プロダクトコード
 * @return {object} 処理結果
 */
export const deleteProgramSetting = (productCd) => async dispatch => {
  const currentSession = await Auth.currentSession();
  const url = clientConfig['api_url'] + '/srv/pgsettings/' + productCd;
  const requestData = {
    method: 'delete',
    url: url,
    headers: { 'Authorization': currentSession.idToken.jwtToken },
  };
  const result = {...response};
  return new Promise((resolve) => {
    axios(requestData)
      .then(res => {
        consoleLogger('API DELETE:' + url);
        consoleLogger(res);
        if (res.status === 200) {
          dispatch({
            type: actions.DELETE_PROGRAM_SETTING,
            product_cd: productCd,
          });
        } else {
          result.errcode = res.data.errcode;
        }
        resolve(result);
      }).catch(err => {
        consoleLogger(err.response);
        if (err.response !== undefined) {
          result.status = err.response.status;
          result.errcode = err.response.data.errcode;  
        } else {
          result.status = 500;
          result.errcode = err.message;  
        }
        resolve(result);       
      });
  });
};

/**
 * 調整プログラム設定を登録する
 * @param {object} params
 * @return {object} 処理結果
 */
export const registProgramSetting = (params) => async dispatch => {
  const currentSession = await Auth.currentSession();
  const url = clientConfig['api_url'] + '/srv/pgsettings/';
  const requestData = {
    method: 'post',
    url: url,
    headers: { 'Authorization': currentSession.idToken.jwtToken },
    params: params
  };
  const result = {...response};
  return new Promise((resolve) => {
    axios(requestData)
      .then(res => {
        consoleLogger('API POST:' + url);
        consoleLogger(res);
        if (res.status === 200) {
          dispatch({ type: actions.REGIST_PROGRAM_SETTING });
        } else {
          result.errcode = res.data.errcode;
        }
        resolve(result);
      }).catch(err => {
        consoleLogger(err.response);
        if (err.response !== undefined) {
          result.status = err.response.status;
          result.errcode = err.response.data.errcode;  
        } else {
          result.status = 500;
          result.errcode = err.message;  
        }
        resolve(result);       
      });
  });
};

/**
 * 調整プログラム設定を更新する
 * @param  {string} productCd プロダクトコード
 * @param  {object} params
 * @return {object} 処理結果 
 */
export const updateProgramSetting = (productCd, params) => async dispatch => {
  const currentSession = await Auth.currentSession();
  const url = clientConfig['api_url'] + '/srv/pgsettings/' + productCd;
  const requestData = {
    method: 'put',
    url: url,
    headers: { 'Authorization': currentSession.idToken.jwtToken },
    params: params
  };
  const result = {...response};
  return new Promise((resolve) => {
    axios(requestData)
      .then(res => {
        consoleLogger('API PUT:' + url);
        consoleLogger(res);
        if (res.status === 200) {
          dispatch({ type: actions.UPDATE_PROGRAM_SETTING });
        } else {
          result.errcode = res.data.errcode;
        }
        resolve(result);
      }).catch(err => {
        consoleLogger(err.response);
        if (err.response !== undefined) {
          result.status = err.response.status;
          result.errcode = err.response.data.errcode;  
        } else {
          result.status = 500;
          result.errcode = err.message;  
        }
        resolve(result);       
      });
  });
};